import {FC} from 'react';
import {SxProps, Theme, Typography} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import {ConsumptionPaymentMode} from 'src/enums';
import theme from 'src/theme';
import {pillFitSx} from 'src/components/common/pillFit.sx';
import {useFitText} from 'src/hooks/useFitText';

export const PaymentModeStatus: FC<{ label: ConsumptionPaymentMode }> = ({label}) => {
    const intl = useIntl();
    const fitRef = useFitText<HTMLSpanElement>(`${intl.locale}:${label}`);
    const calculateBackgroundAndColor = () => {
        switch (label) {
            case ConsumptionPaymentMode.COMPANY: {
                return {
                    background: theme.palette.success.light,
                    color: theme.palette.success.dark,
                };
            }
            case ConsumptionPaymentMode.EMPLOYEE: {
                return {
                    background: theme.palette.primaryColor[50],
                    color: theme.palette.primaryColor[700],
                };
            }
            default: {
                return {
                    background: theme.palette.success.light,
                    color: theme.palette.success.dark,
                };
            }
        }
    };

    const sxValue: SxProps<Theme> = {
        ...calculateBackgroundAndColor(),
        padding: theme.spacing(3 / 8, 6 / 8),
        borderRadius: theme.spacing(4 / 8),
        fontWeight: 500,
        ...pillFitSx,
        [theme.breakpoints.down('md')]: {
            fontSize: theme.spacing(12 / 8),
        },
    };

    const getMessageId = () => {
        switch (label) {
            case ConsumptionPaymentMode.COMPANY:
                return 'paymentModeCompanyStatus';
            case ConsumptionPaymentMode.EMPLOYEE:
                return 'paymentModeEmployeeStatus';
            default:
                return 'paymentModeCompanyStatus';
        }
    };

    return (
        <Typography
            ref={fitRef}
            sx={sxValue}
            component="span"
        >
            <FormattedMessage id={getMessageId()}/>
        </Typography>
    );
};